import { defineStore } from 'pinia';
import { ref, computed, watch } from 'vue';

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null);
  const loading = ref(false);
  const isLoaded = ref(false);
  const completeEmail = ref(null);
  const currentDistrict = computed(() => user?.value?.districts?.find(district => district.current));

  const isAuthenticated = computed(() => user.value !== null);

  // By watching the `districts` array with the `deep: true` option, we ensure that the `currentOffice` computed property
  // updates correctly whenever a district's `current`property is modified.
  watch(() => user.value?.districts, () => {}, { deep: true });

  return {
    user,
    isAuthenticated,
    loading,
    isLoaded,
    completeEmail,
    currentDistrict,
  };
});
